import { createContext } from 'react';

/* what both auth methods (keycloak, simulated) provide; each login
   takes an object of its own shape */
export type Auth = {
  authMode: string;
  user?: { sub?: string; name?: string; email?: string } | null;
  token?: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (args?: Record<string, unknown>) => unknown;
  logout: () => unknown;
  error?: Error | null;
};

export const AuthContext = createContext<Auth | null>(null);
